var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Delegation',{ref:"delegation",attrs:{"delegator":_vm.delegator,"delegatee":_vm.delegatee,"delegation":_vm.delegation}})
}
var staticRenderFns = []

export { render, staticRenderFns }